import { DEVELOPMENT, LOCAL, STAGING } from '@web/common';

export const isLocalOrDev = [LOCAL, DEVELOPMENT].includes(
  process.env['NX_ENVIRONMENT'] ?? '',
);

export const isTestingEnv = [LOCAL, DEVELOPMENT, STAGING].includes(
  process.env['NX_ENVIRONMENT'] ?? '',
);
